import React from "react";
import { Paper, Typography } from "@material-ui/core";
import TrashCan24 from "@carbon/icons-react/lib/trash-can/24";
import PlayOutline24 from "@carbon/icons-react/lib/play--outline/24";
import Box from "@material-ui/core/Box";
import { DateUtils } from "@prestosports/prestostats-core/Common";
import IconButton from "@material-ui/core/IconButton";
import StreamStyles from "../styles/StreamStyles";
import StreamMarkerFbOption from "./StreamMarkerFbOption";

const StreamMarkerPreview = ({
	marker = {},
	handleDeleteMarker,
	handleJumpToMarker,
	footballPlays,
	gameConfig
}) => {
	const classes = StreamStyles();
	const { seconds, id, description, playId } = marker;

	const play = footballPlays.find(({ id: pId }) => pId === playId);

	return (
		<Box className={classes.streamMkrPreviewContainer}>
			<Paper className={classes.streamMkrPreviewPaper}>
				<Typography className={classes.streamMkrPreviewTimestamp} variant="body2">
					{DateUtils.formatMilliseconds(seconds * 1000, [
						"hours",
						"minutes",
						"seconds"
					])}
				</Typography>
				<Typography className={classes.streamMkrPreviewDescription} variant="body2">
					{description}
				</Typography>
				{!!play && <StreamMarkerFbOption play={play} gameConfig={gameConfig} />}
				<Box className={classes.streamMkrPreviewBtnContainer}>
					<IconButton
						aria-label="Jump to marker"
						onClick={() => {
							handleJumpToMarker(id);
						}}
					>
						<PlayOutline24 />
					</IconButton>
					<IconButton
						aria-label="Delete marker"
						onClick={() => handleDeleteMarker(id)}
					>
						<TrashCan24 />
					</IconButton>
				</Box>
			</Paper>
		</Box>
	);
};

export default StreamMarkerPreview;
